module.exports = {"date":"2023-2-21","branch":"rfess","version":"v0.0.2"}


//////////////////
// WEBPACK FOOTER
// ./static/version.json
// module id = c+VB
// module chunks = 2